import React from 'react';
import { ReservationSystem } from '../components/ReservationSystem';
export function ReservationPage() {
  return <main data-id="element-226">
      <ReservationSystem data-id="element-227" />
    </main>;
}